import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	list: []
};

export default function folders(state = initialState, action) {
	
	switch (action.type) {			

		case "IS_FETCHING_FOLDERS":
			return update(state, { isFetching: { $set: action.bool } });

		case "SET_FOLDERS_LIST":
			return update(state, { list: { $set: action.folders } });		

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/domains/folders/reducer.js